import { Component, h, Host, Prop } from '@stencil/core'
import { Award, AwardType } from '../types'

/**
 * The weinfreunde-specific award component represents a round "sticker" by default.
 * The sticker can display a rating score in the form of icons in addition to a headline and
 * body text. For example, wine glasses and stars.
 *
 * @example
 * <wf-award heading="Awesome", value="100" type="glasses"}></wf-award>
 */
@Component({
    tag: 'wf-award',
    styleUrl: 'wf-award.scss',
    shadow: true,
})
// eslint-disable-next-line require-jsdoc
export class WfAward implements Award {
    /**
     * The title of the award.
     */
    @Prop() text?: string
    /**
     * The award type. Available types are "glasses", "points", "text", "color" and "stars".
     */
    @Prop() type?: string | AwardType = 'text'
    /**
     * The value of the type.
     */
    @Prop() value?: number | string
    /**
     * The icon size of the blister.
     */
    @Prop() iconSize ? = 15
    /**
     * The scaling size of the award.
     */
    @Prop() sizing ? = 'l'

    /**
     * @inheritDoc
     */
    render() {
        return (
            <Host class={'sizing-' + this.sizing}>
                <div
                    class={'award-content' + (this.type === 'image' ? ' ' + this.value : '') + ' sizing-' + this.sizing}>
                    {this.blister}
                    {this.heading}
                    <div class="award-text">
                        {this.text}
                    </div>
                </div>
            </Host>
        )
    }

    /**
     * Renders the heading text.
     */
    private get heading() {
        return ['points', 'color'].includes(this.type) &&
            <div class={{ ['award-heading ' + this.type]: true }}>{this.value}</div>
    }

    /**
     * Displays a blister in the form of icons.
     */
    private get blister() {
        return ['stars', 'glasses'].includes(this.type) &&
            <div class={{ ['award-blister ' + this.type]: true }}
                style={{
                    width: this.iconSize * Number(this.value) + 'px',
                    backgroundSize: this.iconSize + 'px',
                }}>
            </div>
    }
}
